import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Logo from '../../assets/images/logo.svg';
import { Input } from '../../components/ui';
import lang from '../../assets/lang';

const Footer = () => {
	const getSocials = () =>
		lang.socialLinks.map(link =>
			<li key={link.platform}>
				<a href={link.link}>
					<span className={`fa fa-${link.platform}`} />
				</a>
			</li>
		);

	const getSiteMap = () =>
		lang.siteMap.map(sMap =>
			<li key={sMap.title}>
				<Link to={sMap.link}>{sMap.title}</Link>
			</li>
		);

	const getProducts = () =>
		lang.products.map(product =>
			<li key={product.title}><a href={product.link}>{product.title}</a></li>
		);

	return (
		<footer className="main-footer">
			<div className="round-layer" />

			<div className="widgets-section">
				<div className="auto-container">
					<Row className="clearfix">
						<Col className="big-column" md={6} sm={12} xs={12}>
							<Row className="clearfix">
								<Col className="footer-column" md={6} sm={6} xs={12}>
									<div className="footer-widget about-widget">
										<div className="logo"><a href="index.html"><img src={Logo} alt="" /></a></div>
										<div className="widget-content">
											<ul className="contact-info">
												<li><a href={`mailto: ${lang.textEmail}`}>{lang.textEmail}</a></li>
												<li><a href={`tel: ${lang.textPhone}`}>{lang.textPhone}</a></li>
											</ul>
										</div>

										<div className="footer-widget links-widget">
											<div className="widget-content">
												<ul className="list" style={{ marginTop: 10 }}>
													<li><Link to={'/service-terms'}>{lang.serviceTerms}</Link></li>
													<li><Link to={'/privacy-policy'}>{lang.privacyPolicy}</Link></li>
													<li><Link to={'/return-policy'}>{lang.returnPolicy}</Link></li>
												</ul>
											</div>
										</div>
									</div>
								</Col>

								<Col className="footer-column" md={6} sm={6} xs={12}>
									<div className="footer-widget links-widget">
										<h2>{lang.titleSiteMap}</h2>
										<div className="widget-content">
											<ul className="list">
												{getSiteMap()}
											</ul>
										</div>
									</div>
								</Col>

							</Row>
						</Col>

						<Col className="big-column" md={6} sm={6} xs={12}>
							<Row className="clearfix">

								<Col className="footer-column" md={6} sm={6} xs={12}>
									<div className="footer-widget links-widget">
										<h2>{lang.titleProducts}</h2>
										<div className="widget-content">
											<ul className="list">
												{getProducts()}
											</ul>
										</div>
									</div>
								</Col>

								<Col className="footer-column" md={6} sm={6} xs={12}>
									<div className="footer-widget newsletter-widget">
										<h2>{lang.titleSubscribe}</h2>
										<div className="widget-content">
											<div className="newsletter-form">
												<form method="post" action="blog.html">
													<FormGroup>
														<Input type="email" name="field-name"
														       placeholder={lang.textSubscribe} required />
														<button type="submit" className="send-btn"><span
															className="fa fa-envelope-o" /></button>
													</FormGroup>
												</form>
											</div>

											<div className="social-links">
												<ul className="clearfix">
													{getSocials()}
												</ul>
											</div>

											<div className='payment-links' style={{ marginTop: 30 }}>
												<img
													style={{ width: 40 }}
													src={require('../../assets/images/visa.png')}
													alt="Visa" />
												<img
													style={{ width: 40, marginLeft: 10 }}
													src={require('../../assets/images/master-card.png')}
													alt="Master Card" />
											</div>
										</div>
									</div>
								</Col>

							</Row>
						</Col>

					</Row>
				</div>
			</div>

			<div className="footer-bottom">
				<div className="auto-container">
					<div className="clearfix">
						<div className="copyright-text text-center">Copyright &copy; {new Date().getUTCFullYear()}. All
							Rights Reserved By <Link to="/">SWAZER</Link></div>
					</div>
				</div>
			</div>

		</footer>
	);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js